/**
 * Brand colors
 */
export const brandColors = {
  teal: '#38a9ae',
  gold: '#f1b51c',
  grey: '#545c70',
  lightGrey: '#dfdbd4',
};
